/**
 * MobileStickyCTA — DÉSACTIVÉ (juin 2026)
 *
 * Ce CTA flottant « Commencer mon parcours » a été supprimé suite à la refonte
 * de la BottomNav (5 onglets factuels : Accueil · Plateau · Circulation · Tutos · Magazine).
 * Avec la nouvelle navigation orientée action, ce CTA générique n'a plus de sens
 * et créait une surcharge visuelle sur mobile.
 *
 * Le composant est conservé pour ne pas casser les imports existants
 * mais retourne null immédiatement.
 */
import React from 'react';

export function MobileStickyCTA() {
  return null;
}

export default MobileStickyCTA;
